import { useState } from 'react'
import useSWR from 'swr'
import { ProfileTypes } from 'types/enums'

import { toastr } from 'components/Toastr'
import { getCustomersInTriage } from 'services/api/formalization-bff/customer-triage/triage'
import { useTranslation } from 'react-i18next'

const THREE_MINUTES = 180000

export function useTriage(
  status = 'formalization',
  profile = ProfileTypes.TeamLeader,
) {
  const { t } = useTranslation(['formalization'])
  const [lastRefreshAt, setLastRefreshAt] = useState(new Date(Date.now()))

  const { data } = useSWR(
    `/formalization/triage/${profile}`,
    () => getCustomersInTriage(status, profile),
    {
      refreshInterval: THREE_MINUTES,
      onSuccess: () => setLastRefreshAt(new Date(Date.now())),
      onError: () => toastr.error(t('notifications.load-customers-failure')),
    },
  )

  return { data, lastRefreshAt }
}
